<template>
  <a-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item label="应用名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'name', validatorRules.name]" placeholder="请输入应用名称"></a-input>
        </a-form-item>
        <a-form-item label="负责人工号" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['manager', validatorRules.manager]" readonly @click="openSelectUser" :trigger-change="true"  ></a-input>
        </a-form-item>
        <a-form-item label="代码仓库地址" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'codeUrl', validatorRules.codeUrl]" placeholder="请输入代码仓库地址"></a-input>
        </a-form-item>
        <a-form-item label="流水线部署地址" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'deploytoolUrl', validatorRules.deploytoolUrl]" placeholder="请输入流水线部署地址"></a-input>
        </a-form-item>
        <a-form-item label="排序" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number v-decorator="[ 'sort', validatorRules.sort]" placeholder="请输入排序" style="width: 100%"/>
        </a-form-item>
        <a-form-item label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'remarks', validatorRules.remarks]" placeholder="请输入备注"></a-input>
        </a-form-item>
        <a-form-item label="是否启用" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-switch  v-decorator="[ 'izActivity', validatorRules.izActivity]" placeholder="请输入是否启用" ></a-switch>
        </a-form-item>
        <a-form-item label="启动步骤" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-editor :key="editorKey" v-decorator="['startStep',{trigger:'input'}]"/>
        </a-form-item>
      </a-form>
    </a-spin>
   <select-user-modal   ref="selectUserModal"  :onlySelectOne="true"  @selectedOne="selectOK"  ></select-user-modal>
  </a-modal>
</template>

<script>

  import { httpAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import SelectUserModal from '@/components/common/SelectUserModal'
  import JEditor from '@/components/jeecg/JEditor'

  export default {
    name: "BusServermanageAppModal",
    components: { 
      SelectUserModal,
      JEditor
    },
    data () {
      return {
        form: this.$form.createForm(this),
        title:"操作",
        width:800,
        visible: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          name: {rules: [
            {required: true, message: '请输入应用名称!'},
            { validator: (rule, value, callback) => validateDuplicateValue('bus_servermanage_app', 'name', value, this.model.id, callback)},
          ]},
          manager: {rules: [
          ]},
          codeUrl: {rules: [
            {pattern:/^(?:([A-Za-z]+):)?(\/{0,3})([0-9.\-A-Za-z]+)(?::(\d+))?(?:\/([^?#]*))?(?:\?([^#]*))?(?:#(.*))?$/, message: '请输入正确的网址!'},
          ]},
          deploytoolUrl: {rules: [
            {pattern:/^(?:([A-Za-z]+):)?(\/{0,3})([0-9.\-A-Za-z]+)(?::(\d+))?(?:\/([^?#]*))?(?:\?([^#]*))?(?:#(.*))?$/, message: '请输入正确的网址!'},
          ]},
          sort: {rules: [
          ]},
          remarks: {rules: [
          ]},
          izActivity: {rules: [
          ],valuePropName: 'checked'},
          delFlag: {rules: [
          ]},
          startStep:{rules:[]},
        },
        url: {
          add: "/servermanage/busServermanageApp/add",
          edit: "/servermanage/busServermanageApp/edit",
        },
        editorKey:new Date().valueOf()
      }
    },
    created () {
    },
    methods: {
      add () {
        this.edit({izActivity:1});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.model.izActivity=(record.izActivity===1)?true:false
        this.visible = true;
        this.$nextTick(() => {
          this.editorKey=new Date().valueOf()
          this.form.setFieldsValue(pick(this.model,'name','manager','codeUrl','deploytoolUrl','sort','remarks','izActivity','delFlag','startStep'))
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'post';
            }
            values.izActivity=values.izActivity?1:0;
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }
         
        })
      },
      handleCancel () {
        this.close()
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'name','manager','codeUrl','deploytoolUrl','sort','remarks','izActivity','delFlag',''))
      },
      selectOK(selectData){
        console.log(selectData)
        this.form.setFieldsValue({
          manager:selectData[0].username,
        })
      },
      getFormFieldValue(field){
        return this.form.getFieldValue(field)
      },
      openSelectUser(record){
        this.$refs.selectUserModal.add();
      },
    }
  }
</script>